/**
 * CDN 线路详情 - 侧边导航菜单
 *
 * 通过 menuContentRender 挂载，只替换 ProLayout sider 的菜单内容区，
 * 保留 sider 的 CSS 结构，风格与系统其他页面完全一致。
 */

import {
  ArrowLeftOutlined,
  ClusterOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import { Menu } from 'antd';
import React from 'react';
import { history, useIntl, useParams } from 'umi';

const LineSideMenu: React.FC = () => {
  const intl = useIntl();
  const { lineId, feature } = useParams<{
    lineId: string;
    feature?: string;
  }>();

  const t = (id: string, msg: string) =>
    intl.formatMessage({ id, defaultMessage: msg });

  const activeTab = feature || 'basic';
  const listPath = '/cdn-ops/lines';
  const lineBasePath = `${listPath}/${lineId}`;

  const menuGroups = [
    {
      type: 'group' as const,
      label: t('cdn.line.sideMenu.group.basic', '线路信息'),
      children: [
        {
          key: 'basic',
          icon: <InfoCircleOutlined />,
          label: t('cdn.line.tab.basic', '基本信息'),
        },
        {
          key: 'nodes',
          icon: <ClusterOutlined />,
          label: t('cdn.line.tab.nodes', '节点配置'),
        },
      ],
    },
  ];

  return (
    <Menu
      mode="inline"
      selectedKeys={[activeTab]}
      style={{ borderRight: 0 }}
      onClick={({ key }) => {
        if (key === '__back__') {
          history.push(listPath);
        } else {
          history.push(`${lineBasePath}/${key}`);
        }
      }}
      items={[
        {
          key: '__back__',
          icon: <ArrowLeftOutlined />,
          label: t('cdn.line.sideMenu.backToList', '返回线路列表'),
        },
        { type: 'divider' },
        ...menuGroups,
      ]}
    />
  );
};

export default LineSideMenu;
